export default __webpack_public_path__ + "static/media/signetsimple_light.604822b6.png";